<template>
  <div class="help-header">
    <div class="container mb-0 py-0">
      <div class="row align-items-center">
        <div>
          <img
            :src="`${useAsset('img/credit-line/back-button.png')}`"
            @click="goBack"
            alt="back"
          />
          <span class="ms-0 text-black" style="font-weight: 600">
            {{ t("FAQ") }}
          </span>
        </div>
      </div>
    </div>
  </div>
  <hr class="w-100 mx-0 p-0 mt-2" />
  <FAQS faq-param="pay" country="MX" />
</template>

<script setup lang="ts">
import FAQS from "@/apps/credit-line/components/Help/Faqs.vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import { useI18n } from "@/apps/credit-line/composables/useI18n";

const { t } = useI18n();

const goBack = () => {
  window.history.back();
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.help-header {
  background-color: $pj-color-white;
  padding: 0;
  @media screen and (max-width: $mobile) {
  }

  & + hr + section {
    margin-top: 2rem;
  }
}
</style>
